module.exports = __webpack_public_path__ + "static/media/dieren-dokters-zeist.120e1aca.jpg";